import View from './view';
import {target} from '../utils/dom';
import getOffset from '../utils/get-offset';
import scrollPos from '../utils/scroll-position';
import scrollTo from '../utils/scroll-to';

const changedEvent = new CustomEvent('projectsFilterChanged', {bubbles: true});

const defaults = {
	el: null,
	triggerAttribute: 'data-filter-trigger',
	selectedAttribute: 'data-filter-selected',
	multiselectAttribute: 'data-multiselect',
	itemSelector: '[data-filter]',
	filterContainer: 'slx-filter',
	filterTotalContainer: 'slx-filter__total',
	allElementsCounterContainer: 'slx-filter__allElementCounter',
	allElementsCounterButton: 'slx-filter__seeElementsButton',
	filteredContainer: 'slx-productsContainer',
};

class Filter extends View {
	constructor(options) {
		super(options, defaults);
		if (this.el.getElementsByClassName(this.params.filterContainer).length === 0) return;
		this.timer = null;
		this.triggerSelector = `[${this.params.triggerAttribute}]`;
		this.triggers = this.el.queryAll(this.triggerSelector);
		this.items = this.el.queryAll(this.params.itemSelector);
		this.multiselect = this.el.getElementsByClassName(this.params.filterContainer)[0].getAttribute(this.params.multiselectAttribute) === '';
		const selected = this.el.query(`[${this.params.selectedAttribute}]`);
		if (selected) {
			this.triggerFilter(selected);
		}

		this.applyFilter(window.location.hash.slice(1));

		document.dispatchEvent(changedEvent);
	}

	initEvents() {
		super.initEvents();
		this.el.addEventListener('click', this.onClick.bind(this));
		window.onhashchange = function () {
			this.applyFilter(window.location.hash.slice(1));
		}.bind(this);

		this.allElementsCounterButton = this.el.getElementsByClassName(this.params.allElementsCounterButton)[0];
		if(this.allElementsCounterButton) {
			this.allElementsCounterButton.addEventListener('click', this.onAllElementsCounterButtonClick.bind(this));
		}
	}

	onClick(event) {
		const trigger = target(event.target, this.triggerSelector);
		if (trigger) {
			event.preventDefault();
			this.triggerFilter(trigger);
		}
	}

	onAllElementsCounterButtonClick(e) {
		this.filteredContainer = document.getElementsByClassName(this.params.filteredContainer)[0];
		if(this.filteredContainer) {
			scrollTo(getOffset(this.filteredContainer).top);
		}
	}

	countItems(selectedFilters, newFilter) {
		const newFilters = new Set(selectedFilters);
		newFilters.add(newFilter);
		let count = 0;
		this.items.forEach((item, index) => {
			let itemFilters = new Set(
				item.getAttribute('data-filter').split(', ')
			);
			let intersection = new Set(
				[...itemFilters].filter(x => newFilters.has(x))
			);
			if (intersection.size === newFilters.size) {
				count++;
			}
		});
		return count;
	}

	updateTrigger(trigger, selectedFilters) {
		const triggerFilter = trigger.getAttribute('data-filter-trigger');
		const isActive = selectedFilters.has(triggerFilter);
		const totalElement = trigger.getElementsByClassName(this.params.filterTotalContainer)[0];

		if (isActive) {
			trigger.classList.add('active');
		} else {
			trigger.classList.remove('active');
		}
		if (this.multiselect) {
			const count = this.countItems(selectedFilters, triggerFilter);
			if(totalElement) totalElement.innerHTML = ` ${count}`;
			if (count === 0) {
				trigger.classList.add('disabled');
			} else {
				trigger.classList.remove('disabled');
			}
		}
	}

	triggerFilter(trigger) {
		const selectedFilters = new Set();
		trigger.classList.toggle('active');
		if (!this.multiselect) {
			this.el.queryAll(this.triggerSelector).forEach((item) => {
				if (item !== trigger) {
					item.classList.remove('active');
				}
			});
		}
		//this.el.classList.add('hide');

		if (this.timer) {
			clearTimeout(this.timer);
		}
		this.timer = setTimeout(() => {
			document.queryAll(`${this.triggerSelector}.active`).forEach((el) => {
				selectedFilters.add(el.getAttribute(this.params.triggerAttribute));
			});
			window.location.hash = [...selectedFilters].join(',');
			this.events.emit('done');
		}, 200); // Wait for CSS animation on container
	}

	applyFilter(selectedFilterString) {
		let selectedFilters = new Set();
		if (selectedFilterString !== '') {
			selectedFilters = new Set(selectedFilterString.split(','));
		}
		let count = 0;
		this.items.forEach((item, index) => {
			let itemFilters = new Set(
				item.getAttribute('data-filter').split(', ')
			);
			let intersection = new Set(
				[...itemFilters].filter(x => selectedFilters.has(x))
			);
			if (intersection.size === selectedFilters.size) {
				item.classList.remove('inactive');
				count++;
			} else {
				item.classList.add('inactive');
			}
		});
		this.updateAllElementsCounter(count);
		this.triggers.forEach((triggerEl, index) => {
			this.updateTrigger(triggerEl, selectedFilters);
		});
		this.el.classList.remove('hide');
		setTimeout(() => {
			document.dispatchEvent(changedEvent);
		}, 300);
	}

	updateAllElementsCounter(count) {
		//update counter
		const allElementsCounter = this.el.getElementsByClassName(this.params.allElementsCounterContainer)[0];
		if (allElementsCounter) {
			allElementsCounter.innerHTML = `${count}`;
		}
	}
}

export default Filter;
